import { AppointmentStatusCodes } from '@lmt/shared-types';
import {
  Chip,
  ChipColor,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/Chip';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface VisitStatusOptionProps {
  status: AppointmentStatusCodes;
}

export const VisitStatusOption: FC<VisitStatusOptionProps> = (props) => {
  const { status } = props;

  const i18next = useTranslation();

  if (status === AppointmentStatusCodes.Completed) {
    return (
      <Chip
        title={i18next.t(`visit_status.${status}`)}
        color={ChipColor.Secondary}
      />
    );
  }
  if (status === AppointmentStatusCodes.Planned) {
    return (
      <Chip
        title={i18next.t(`visit_status.${status}`)}
        color={ChipColor.Primary}
      />
    );
  }
  if (status === AppointmentStatusCodes.Canceled) {
    return (
      <Chip
        title={i18next.t(`visit_status.${status}`)}
        color={ChipColor.Danger}
      />
    );
  }
  if (status === AppointmentStatusCodes.Confirmed) {
    return (
      <Chip
        title={i18next.t(`visit_status.${status}`)}
        color={ChipColor.Secondary}
      />
    );
  }

  return null;
};
